import profile from "../assets/png/profile.PNG";

export const headerData = {
    name: '',
    title: 'Hi there 👋',
    desciption: "My passion for technology fuels my drive to embrace new challenges, and help clients achieve their digital aspirations. If you're on the lookout for a dedicated, dependable freelance full stack developer to spearhead your upcoming projects, I will be glad to help you !",
    image: profile,
}